export default {
  navData: [
    {path: '/', name: '博客', icon: ''},
    {path: '/message', name: '留言板', icon: ''},
    {path: '/movie',
      name: '电影',
      children: [
        {path: '/movie', name: '电影', icon: ''},
        {path: '/movie/department', name: '系列电影', icon: ''}
      ],
      icon: ''},
    {path: '/tvseries', name: '电视剧', icon: ''},
    {path: '/comic', name: '动漫', icon: ''},
    {path: '/study', name: '学习', icon: ''},
    {path: 'https://home.doyle.wang:32400/', name: 'PLEX', icon: ''},
    {path: '/software', name: '软件', icon: ''},
    {path: '/resume', name: '简历', icon: ''},
    {path: '/about',
      name: '关于',
      children: [
        {path: '/about/station', name: '关于本站', icon: ''},
        {path: '/about/feedback', name: '问题反馈', icon: ''},
        {path: '/about/download', name: '相关下载', icon: ''}
      ],
      icon: ''}
    // {path: '/navi', name: '导航', icon: ''}
    // {path: '/certification',
    //   name: '认证简介',
    //   children: [
    //     {path: '/certification/introduce', name: '证书介绍', icon: ''},
    //     {path: '/certification/advantage', name: '培训认证优势', icon: ''}
    //   ],
    //   icon: ''},
    // {path: '/meet', name: '会议报名', icon: ''},
    // {path: '/information',
    //   name: '考试资讯',
    //   children: [
    //     {path: '/information/intro', name: '考试信息', icon: ''},
    //     {path: '/information/station', name: '考点信息', icon: ''},
    //     {path: '/information/method', name: '报考指南', icon: ''},
    //     {path: '/information/examine', name: '考核大纲', icon: ''}
    //   ],
    //   icon: ''},
    // {path:'/question',name:'在线考试',icon:'',},
    // {path: '/study',
    //   name: '学习资源',
    //   children: [
    //     {path: '/study/textbook', name: '教材中心', icon: ''},
    //     {path: '/study/video', name: '在线学习中心', icon: ''},
    //     // {path: '/study/practice', name: '模拟练习平台', icon: ''}
    //     {path: '/examinelogin', name: '模拟考试系统', icon: ''}
    //   ],
    //   icon: ''},
    // {path: '/query',
    //   name: '考试信息查询',
    //   children: [
    //     {path: '/query/signup', name: '考试报名须知', icon: ''},
    //     {path: '/query/credentials', name: '准考证查询', icon: ''},
    //     {path: '/query/grade', name: '成绩、证书查询', icon: ''},
    //     {path: '/query/post', name: '领取证书', icon: ''}
    //   ],
    //   icon: ''},
    // {path:'/personal',name:'个人中心',icon:'',},
    // {path: '/download', name: '考试软件下载', icon: ''},
    // {path: '/backmanage', name: '管理平台', icon: ''},
    // {path: '/examstation/login', name: '考点考务', icon: ''},
    // {path: '/about',
    //   name: '关于',
    //   children: [
    //     {path: '/about/company', name: '认证机构', icon: ''},
    //     {path: '/about/contact', name: '联系我们', icon: ''},
    //     {path: '/about/feedback', name: '问题反馈', icon: ''}
    //     // {path: '/about/certification', name: '多式联运组织与管理1+X职业等级证书介绍', icon: ''}
    //   ],
    //   icon: ''}
  ],
  certification: {
    imageName: 'bg_news',
    chineseStr: '认证简介',
    englishStr: 'CERTIFICATION',
    tags: [
      {name: '证书介绍', path: '/certification/introduce'},
      {name: '培训认证优势', path: '/certification/advantage'}
    ]
  },
  information: {
    imageName: 'bg_news',
    chineseStr: '考试咨询',
    englishStr: 'INFORMATION',
    tags: [
      {name: '考试信息', path: '/information/intro'},
      {name: '考点信息', path: '/information/station'},
      {name: '报考指南', path: '/information/method'},
      {name: '考核大纲', path: '/information/examine'}
    ]
  },
  study: {
    imageName: 'bg_news',
    chineseStr: '学习中心',
    englishStr: 'STUDY',
    tags: [
      {name: '教材中心', path: '/study/textbook'},
      {name: '串讲视频', path: '/study/video'},
      {name: '模拟练习平台', path: '/study/practice'}
    ]
  },
  query: {
    imageName: 'bg_news',
    chineseStr: '考试信息查询',
    englishStr: 'QUERY',
    tags: [
      {name: '考试报名须知', path: '/query/signup'},
      {name: '准考证查询', path: '/query/credentials'},
      {name: '成绩、证书查询', path: '/query/grade'},
      {name: '领取证书', path: '/query/post'}
    ]
  },
  about: {
    imageName: 'bg_about',
    chineseStr: '关于',
    englishStr: 'ABOUT',
    tags: [
      {name: '关于本站', path: '/about/station'},
      {name: '问题反馈', path: '/about/feedback'},
      {name: '相关下载', path: '/about/download'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/pc/Config.js